import React from 'react'

type BaseTablePropsType = {
  children: React.ReactNode
  width?: number | string
  backgroundColor?: string
  className?: string
  id?: string
}

function BaseTable({ children, width, backgroundColor, className, id }: BaseTablePropsType) {
  const styles: Record<string, string | number> = {
    width: width || '100%',
    borderSpacing: 0,
    backgroundColor,
  }

  return (
    <table
      id={id}
      role="presentation"
      border={0}
      cellPadding="0"
      cellSpacing="0"
      className={className}
      width={width || '100%'}
      style={styles}
    >
      <tbody>
        <tr>
          <td align="center">{children}</td>
        </tr>
      </tbody>
    </table>
  )
}

export default BaseTable
